import React, { useEffect, useState } from "react";
import CtiScreenImage from "../../assets/cti-screen-pop.png";
import LogoIcon from "../../assets/logo-icon.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import OTPVerification from "../../components/Auth/OTPVerification";
import CustomButton from "../../components/Button/CustomButton";
import SocialLogin from "../../components/Auth/Login/SocialLogin";
import { Link, useNavigate, useParams } from "react-router-dom";
import apiClient from "../../services/apiClient";
import { setUserDetails } from "../../features/user/UserSlice";
import { useDispatch } from "react-redux";
import CreateCompany from "../../components/Company/CreateCompany";
import toast from "react-hot-toast";
import { updateSipConfig } from "../../features/SIP/SIPConfigSlice";
import loginScreenImg from "../../assets/login-screen-img.png";

const LoginScreen = () => {
  const [currentScreen, setCurrentScreen] = useState("SIGN_UP");
  const [companyOwner, setCompanyOwner] = useState();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      fetchInviteEmail();
    }
    // console.log(id);
  }, []);

  const fetchInviteEmail = async () => {
    try {
      const payload = {
        invitation_id: id,
      };
      const response = await apiClient.post("/inviteSignup", payload);
      setEmail(response?.email);
    } catch (err) {
      console.log(err);
    }
  };

  // Function to switch to the OTP screen
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        email_id: email,
      };
      await apiClient.post("/authUser", payload);

      setCurrentScreen("OTP_SCREEN");
      toast.success("OTP Sent");
    } catch (err) {
      console.log("error!", err);
    } finally {
      setLoading(false);
    }
  };

  // Function to close the popup after OTP submission
  const handleOTPSubmit = (response) => {
    // console.log(response);

    if (!response?.user?.company_id && !id) {
      setCurrentScreen("CREATE_COMPANY");
      setCompanyOwner(response?.user?.id);
    } else {
      dispatch(
        setUserDetails({
          id: response?.user?.id,
          company_id: response?.user?.company_id,
          name: response?.user?.name,
          email: response?.user?.email_id,
          phone_number: response?.user?.phone_number,
          image: response?.user?.image,
          role: response?.user?.user_type,
          company_domain: response?.user?.company_details?.domain,
          settings: response?.user?.settings,
        })
      );

      dispatch(
        updateSipConfig({
          sipUsername: response?.user?.settings?.default_extension?.extension,
          sipPassword: response?.user?.settings?.default_extension?.password,
          sipServer: response?.user?.company_details?.domain,
        })
      );

      if (response?.user?.name.length) {
        toast.success("Welcome!");
        navigate("/");
      } else {
        toast("please complete your profile!");
        navigate("/profile-page");
      }
    }
  };

  return (
    <section className="loginForm text-center">
      <div className="container-fluid min-vh-100 d-flex align-items-center p-0">
        <div className="row m-0 w-100 min-vh-100">
          <div className="col-md-5 d-flex min-vh-100 flex-column justify-content-center align-items-center bg-light p-4">
            <div className="mb-4">
              <img src={LogoIcon} alt="Logo" style={{ width: "100px" }} className="img-fluid" />
            </div>

            {currentScreen === "SIGN_UP" && (
              <>
                <div className="w-75">
                  <h3 className="title">Sign in to your account</h3>

                  {id ? (
                    <>
                      <p className="subTitle">*Use the email you are invited with.</p>
                    </>
                  ) : (
                    <>
                      <SocialLogin
                        handleSocialLoginResponse={(response) => handleOTPSubmit(response)}
                      />
                      <div className="d-flex justify-content-center my-2">
                        <hr className="w-25 mx-2" />
                        <p>or continue with email</p>
                        <hr className="w-25 mx-2" />
                      </div>
                    </>
                  )}

                  <form onSubmit={handleLoginSubmit} className="mt-4">
                    <div className="inputData withIcon my-3">
                      <span className="icon">
                        <MailOutlineIcon />
                      </span>
                      <input
                        type="email"
                        name="email"
                        className="form-control my-2"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={id}
                      />
                      {id ? "" : <label htmlFor="email">Email</label>}
                    </div>

                    <CustomButton
                      type="submit"
                      className="my-2"
                      width={"100%"}
                      size="large"
                      loading={loading}
                    >
                      Sign in
                    </CustomButton>
                  </form>
                </div>

                <p className="resend">
                  Don't have an account?{" "}
                  <Link className="" to={"/sign-up"}>
                    Sign Up
                  </Link>
                </p>

                <p className="footerAuth">
                  <small>
                    <a href="/privacy-policy">Privacy Policy</a> | <a href="/contact">Contact Us</a>
                  </small>
                </p>
              </>
            )}
            {currentScreen === "OTP_SCREEN" && (
              <OTPVerification
                handleOTPSubmit={handleOTPSubmit}
                resendOTP={handleLoginSubmit}
                email={email}
                onBack={() => setCurrentScreen("SIGN_UP")}
              />
            )}

            {currentScreen === "CREATE_COMPANY" && (
              <>
                <CreateCompany user_id={companyOwner} />
              </>
            )}
          </div>

          <div className="col-md-7 d-none d-md-flex align-items-center justify-content-center">
            <div className="fromImage">
              {/* <img src={CtiScreenImage} alt="Right Section" className="img-fluid" /> */}
              <img src={loginScreenImg} className="img-fluid" />
              <h3 className="mb-2">Transform Every Call into a Success</h3>
              <p>
                Maximize Efficiency and Customer Satisfaction with
                <br className="d-non d-xl-block" />
                Our Intuitive Calling CRM Solution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginScreen;
